import React from "react";
import cx from '../../styles';

const HiddenContentBanner = (props) => {
    return (
        <div className={cx('hidden-content-banner')} style={{backgroundColor: `${props.data.background_color}`}}>
            <p className={cx('hidden-content-message')} style={{color: `${props.data.text_color}`}}>
                <span dangerouslySetInnerHTML={{__html: props.data.title}}></span>
            </p>
        </div>
    )
}

export default HiddenContentBanner;